import { Clapperboard, Film, Home, PlusSquare, Shield, Trophy, UserCircle } from 'lucide-react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { isAdminEmail } from '../lib/admin';
import { useAuth } from '../lib/auth';
import { AppDownloadBanner } from './AppDownloadBanner';

const baseTabs = [
  { to: '/feed', label: 'Feed', icon: Home },
  { to: '/shows', label: 'Shows', icon: Clapperboard },
  { to: '/create', label: 'Create', icon: PlusSquare },
  { to: '/vote', label: 'Vote', icon: Trophy },
];

export function BrandMark() {
  return (
    <div className="brand-mark" aria-label="InstaFlix">
      <Film size={18} aria-hidden="true" />
      <span>InstaFlix</span>
    </div>
  );
}

export function AppShell() {
  const { user, profile, signOutUser } = useAuth();
  const location = useLocation();
  const tabs = isAdminEmail(user?.email) ? [...baseTabs, { to: '/admin', label: 'Admin', icon: Shield }] : baseTabs;
  const isFeed = location.pathname === '/feed';
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <main className={isAdmin ? 'site-stage admin-stage' : 'site-stage'}>
      <section className={isAdmin ? 'phone-frame admin-frame' : 'phone-frame'} aria-label={isAdmin ? 'InstaFlix admin dashboard' : 'InstaFlix mobile web app'}>
        {!isAdmin && <AppDownloadBanner />}
        {(!isFeed || isAdmin) && (
          <header className="top-bar">
            <BrandMark />
            {user ? (
              <button className="avatar-button" type="button" onClick={signOutUser} title="Sign out">
                {profile?.avatarUrl ? <img src={profile.avatarUrl} alt="" /> : <UserCircle size={20} />}
              </button>
            ) : (
              <NavLink className="login-link" to="/login">
                Login
              </NavLink>
            )}
          </header>
        )}
        <div className={isAdmin ? 'screen-area admin-screen-area' : isFeed ? 'screen-area screen-area-feed' : 'screen-area'}>
          <Outlet />
        </div>
        {!isAdmin && <nav className="bottom-tabs" aria-label="Primary">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) => `tab-button ${isActive ? 'active' : ''}`}
                end={tab.to !== '/shows'}
              >
                <Icon size={22} strokeWidth={2.3} aria-hidden="true" />
                <span>{tab.label}</span>
              </NavLink>
            );
          })}
        </nav>}
      </section>
    </main>
  );
}
